'use client';

import {
  TOKEN_KEY,
  TOKEN_TIMESTAMP_KEY,
  WEB_SESSION_DURATION_MS
} from '@/constants/auth';
import { dispatchStorageEvent } from '@/hooks/useLocalStorage';

export const getJWT = (): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(TOKEN_KEY);
};

export const setJWT = (token: string): void => {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(TOKEN_KEY, token);
  if (!localStorage.getItem(TOKEN_TIMESTAMP_KEY)) {
    localStorage.setItem(TOKEN_TIMESTAMP_KEY, Date.now().toString());
  }
  dispatchStorageEvent(TOKEN_KEY);
};

export const removeJWT = (): void => {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_TIMESTAMP_KEY);
  dispatchStorageEvent(TOKEN_KEY);
};

export const isWebSessionExpired = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    return false;
  }
  const timestamp = localStorage.getItem(TOKEN_TIMESTAMP_KEY);
  if (!timestamp) {
    // Token exists but no timestamp — treat as expired to force re-login
    return true;
  }
  return Date.now() - parseInt(timestamp, 10) >= WEB_SESSION_DURATION_MS;
};

/**
 * Returns milliseconds until the web session expires, or 0 if already expired / no session.
 */
export const getWebSessionTimeRemaining = (): number => {
  if (typeof window === 'undefined') {
    return 0;
  }
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    return 0;
  }
  const timestamp = localStorage.getItem(TOKEN_TIMESTAMP_KEY);
  if (!timestamp) {
    return 0;
  }
  const remaining =
    WEB_SESSION_DURATION_MS - (Date.now() - parseInt(timestamp, 10));
  return Math.max(0, remaining);
};
